import React from 'react';
import './index.scss';

type ButtonPrimaryProps = {
  id?: string,
  type: 'button' | 'submit' | 'reset';
  children: React.ReactNode;
  onClick?: () => void;
  size?: 'large' | 'medium' | 'small';
  active?: boolean;
  disabled?: boolean;
  variant?: string;
  className?: string;
  style?: React.CSSProperties;
};

export const ButtonPrimary = ({
  id,
  type,
  children,
  onClick,
  size = 'large',
  active,
  disabled,
  variant,
  className,
  style,
}: ButtonPrimaryProps) => {
  return (
    <button
      id={id}
      type={type}
      disabled={disabled}
      onClick={onClick}
      className={`ButtonPrimary ButtonPrimary-${size} ${
        active ? 'ButtonPrimary--active' : ''
      } ${variant ? 'ButtonPrimary--' + variant : ''} ${
        className ?? ''
      }`}
      style={style}
    >
      {children}
    </button>
  );
};
